import React from "react";

const summary = <div>
<p>After losing his wife and young son in a devastating hit-and-run, fisherman Jake Thompson takes justice into his own hands, leading to the death of the man he believes is responsible.</p>

<p>But as the case unfolds, the truth begins to fracture.</p>

<p>The victim, Winston Chow, is the son of a powerful Triad leader tied to a sprawling fentanyl empire and money laundering operation in Vancouver, B.C. As Jake's confession pulls him into a dangerous criminal underworld, lawyer Alex Wong—haunted by her own family's connection to the drug crisis—uncovers a network of corruption reaching deep into law enforcement and the justice system.</p>

<p>At the centre of it all is Candace Chow, Winston's enigmatic wife. She and Jake have formed a fragile bond while on the run, but neither can fully trust the other. Hidden motives and long-buried secrets begin to surface—casting doubt on everything Jake thought he knew.</p>

<p>With powerful forces closing in and the truth slipping further out of reach, Jake finds himself pulled between love and justice, each demanding a different kind of sacrifice.</p>

<p>A gripping, multi-layered thriller, Drowning Man explores grief, redemption, and the cost of truth in a world where nothing is as it seems.</p>
</div>;

export default summary;